/* eslint-disable no-use-before-define,no-param-reassign,import/prefer-default-export */
import { slideDown, slideUp } from '../../slide_toggle';

// PC/SPの検索条件を変更した時の処理
export function searchConditionChange() {
  const form = document.querySelector('form[action="/jobs/search"]');
  const inputPrefecture = form.querySelector('#js-input-prefecture');
  const inputLicense = form.querySelector('#js-input-license');

  // [PCのみ] 検索フォームの開閉
  setSlideToggleForSearchForm();

  // [初回のみ] 都道府県の子のチェックがtr要素内全てONの場合、tr要素内の親のチェックをつける
  initializePrefectureParentCheckbox(form);

  // 親子のチェックボックスの値変更時の処理
  onParentChildCheckboxChanged(form, inputPrefecture, inputLicense);

  // リセットボタンをクリックされた時の処理
  clickedResetButton(form, inputPrefecture, inputLicense);
}

// [初回のみ] 都道府県の子のチェックがtr要素内全てONの場合、tr要素内の親のチェックをつける
function initializePrefectureParentCheckbox(form) {
  const prefectureParentCheckboxes = form.querySelectorAll('.js-parent-checkbox');
  prefectureParentCheckboxes.forEach((prefectureParentCheckbox) => {
    // `tr`要素まで遡りそこに所属する子のcheckboxを取得
    const childrenCheckboxes = prefectureParentCheckbox.closest('tr').querySelectorAll('.js-child-checkbox');
    // 子のチェックボックスが全てチェックされたかどうかを判定
    const allChecked = Array.from(childrenCheckboxes).every(child => child.checked);
    // 親のチェックボックスを変更
    prefectureParentCheckbox.checked = allChecked;
  });
}

// [PCのみ] 検索条件のフォームの開閉
function setSlideToggleForSearchForm() {
  const searchFormToggle = document.querySelector('#js-search_form_toggle');
  const searchForm = document.querySelector('#js-search_form');
  if (!searchFormToggle || !searchForm) return;

  searchFormToggle.addEventListener('click', () => {
    if (searchForm.classList.contains('-opened')) {
      // 閉じる処理
      slideUp(searchForm);
      searchForm.classList.remove('-opened');
    } else {
      // 開く処理
      slideDown(searchForm);
      searchForm.classList.add('-opened');
    }
  });
}


// 親子のチェックボックスの値変更時の処理
function onParentChildCheckboxChanged(form, inputPrefecture, inputLicense) {
  const checkboxes = form.querySelectorAll('.js-parent-child-checkbox input[type=checkbox]');
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      // `.js-parent-checkbox`があるかどうか
      if (checkbox.classList.contains('js-parent-checkbox')) {
        onParentCheckboxChanged(checkbox);
      } else {
        onChildCheckboxChanged(checkbox);
      }

      // SPの場合は、チェックボックスの値をテキストに反映させる
      // SPのみ表示の要素があるかどうか
      if (inputPrefecture && inputLicense) {
        // name属性に`prefecture_names`が含まれる子のチェックボックスの値を取得
        const prefectureNames = Array.from(form.querySelectorAll('input[name="jobs_search[prefecture_names][]"].js-child-checkbox'))
          .filter(prefectureName => prefectureName.checked)
          .map(prefectureName => prefectureName.value);
        // name属性に`license_names`が含まれる子のチェックボックスの値を取得
        const licenseNames = Array.from(form.querySelectorAll('input[name="jobs_search[license_names][]"].js-child-checkbox'))
          .filter(licenseName => licenseName.checked)
          .map(licenseName => licenseName.value);
        // inputPrefectureのテキストを反映させる(input要素ではなくdiv要素になっているため)
        inputPrefecture.textContent = prefectureNames.join(',');
        // inputLicenseのテキストを反映させる(input要素ではなくdiv要素になっているため)
        inputLicense.textContent = licenseNames.join(',');
      }
    });
  });
}

// 親のチェックボックスがチェックされた際のロジック
function onParentCheckboxChanged(checkbox) {
  // `tr`要素まで遡りそこに所属する子のcheckboxを取得
  const childrenCheckboxes = checkbox.closest('tr').querySelectorAll('.js-child-checkbox');
  childrenCheckboxes.forEach((childCheckbox) => {
    if (checkbox.checked) {
      // 親がONの時、所属する全ての子をONにする
      childCheckbox.checked = true;
    } else {
      // 親がOFFの時、所属する全ての子をOFFにする
      childCheckbox.checked = false;
    }
  });
}

// 子のチェックボックスがチェックされた際のロジック
function onChildCheckboxChanged(checkbox) {
  // `tr`要素まで遡りそこに所属する親のcheckboxを取得
  const group = checkbox.closest('tr');
  const parentCheckbox = group.querySelector('.js-parent-checkbox');
  // 親チェックボックスが存在する時
  if (parentCheckbox) {
    // 子のチェックボックスが全てチェックされたかどうかを判定
    const allChecked = Array.from(group.querySelectorAll('.js-child-checkbox')).every(child => child.checked);
    // 親のチェックボックスを変更
    parentCheckbox.checked = allChecked;
  }
}

// リセットボタンをクリックされた時の処理
function clickedResetButton(form, inputPrefecture, inputLicense) {
  const formResetButton = form.querySelector('#js-form-reset');

  formResetButton.addEventListener('click', () => {
    // テキストボックスの値を全て空にする
    const textboxes = form.querySelectorAll('input[type="text"]');
    textboxes.forEach((textbox) => {
      textbox.value = '';
    });

    // セレクトボックスの値を初期値に戻す
    const selectboxes = form.querySelectorAll('select');
    selectboxes.forEach((selectbox) => {
      // 初期状態に戻すためにはselectedIndexを0に設定する
      selectbox.selectedIndex = 0;
    });

    // 検索条件のチェックボックスを全て外す
    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    // inputPrefecture, inputLicenseのテキストを初期値に戻す
    if (inputPrefecture && inputLicense) {
      inputPrefecture.textContent = '';
      inputLicense.textContent = '';
    }
  });
}
